import { Injectable } from '@angular/core';
import {
  PathwayPageUsageInput,
  ReportDownloadedGQL,
  ReportSharedGQL,
  SavePathwayPageUsageGQL,
  SaveVideoUsageGQL,
  StartInterestsTrackingGQL,
  UserInterestSurveyTracker,
  VideoUsage,
  VideoUsageInput
} from '@cpd-app/generated';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TrackerService {
  constructor(
    private saveVideoUsageGQL: SaveVideoUsageGQL,
    private reportDownloadedGQL: ReportDownloadedGQL,
    private reportSharedGQL: ReportSharedGQL,
    private startInterestsTrackingGQL: StartInterestsTrackingGQL,
    private savePathwayPageUsageGQL: SavePathwayPageUsageGQL
  ) {}

  public saveVideoUsave(input: VideoUsageInput): Observable<VideoUsage> {
    return this.saveVideoUsageGQL
      .mutate({
        videoUsageInput: input
      })
      .pipe(map((results) => results?.data?.saveVideoUsage));
  }

  public reportDownloaded(): Observable<{ success: boolean }> {
    return this.reportDownloadedGQL
      .mutate()
      .pipe(map((results) => results?.data?.reportDownloaded));
  }

  public reportShared(): Observable<{ success: boolean }> {
    return this.reportSharedGQL
      .mutate()
      .pipe(map((results) => results?.data?.reportShared));
  }

  public startInterestsTracking(): Observable<UserInterestSurveyTracker> {
    return this.startInterestsTrackingGQL
      .mutate()
      .pipe(map((results) => results?.data?.startInterestsTracking?.tracker));
  }

  public savePathwayPageUsage(
    input: PathwayPageUsageInput
  ): Observable<boolean> {
    return this.savePathwayPageUsageGQL
      .mutate({
        input
      })
      .pipe(map((results) => results?.data?.savePathwayPageUsage));
  }
}
